import { c as _c } from "react/compiler-runtime";
import { type NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import type { MentionKind } from './types';
import { getEntityHref, getIconForKind } from './utils';
const KNOWN_KINDS: MentionKind[] = ['person', 'business', 'playbook', 'investigation', 'onboarding', 'agent_version', 'agent'];
const isMentionKind = (value: string): value is MentionKind => (KNOWN_KINDS as string[]).includes(value);
const MentionPill = t0 => {
  const $ = _c(16);
  const {
    node
  } = t0;
  const id = node.attrs.id ?? "";
  const label = node.attrs.label || id;
  const kind = isMentionKind(node.attrs.kind) ? node.attrs.kind : "person";
  let t1;
  if ($[0] !== kind) {
    t1 = getIconForKind(kind);
    $[0] = kind;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const Icon = t1;
  let t2;
  if ($[2] !== id || $[3] !== kind) {
    t2 = getEntityHref(id, kind) ?? undefined;
    $[2] = id;
    $[3] = kind;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      fontSize: "inherit",
      lineHeight: "inherit",
      fontWeight: 400
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== Icon) {
    t4 = <span aria-hidden="true" className="shrink-0 inline-flex items-center [&_svg]:w-3 [&_svg]:h-3"><Icon color="accent" /></span>;
    $[6] = Icon;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== label) {
    t5 = <span>{label}</span>;
    $[8] = label;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== id || $[11] !== kind || $[12] !== t2 || $[13] !== t4 || $[14] !== t5) {
    t6 = <NodeViewWrapper as="a" data-mention="true" data-id={id} data-kind={kind} href={t2} target="_blank" rel="noreferrer" title={id} contentEditable={false} style={t3} className="fp-mention inline-flex items-center gap-0.5 align-baseline rounded-md border border-tertiary bg-secondary px-1 py-0 text-accent hover:underline cursor-pointer no-underline" onMouseDown={_temp} onClick={_temp2}>{t4}{t5}</NodeViewWrapper>;
    $[10] = id;
    $[11] = kind;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default MentionPill;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}